export default "__VITE_ASSET__BgBL4bQa__"